import React, { Component } from "react";
import { Button, Form, Icon, Input, Row, Col, Divider, Tooltip } from "antd";
import { message } from "antd/lib/index";
import CircularProgress from "components/CircularProgress/index";
import {createDataUnAuth } from '../../util/API';
import { s3SignedUrl } from "../../util/S3Functions";

function generateSignedUrl(url) {
  const link = s3SignedUrl(url);
  window.open(link, "_blank"); //to open new page
}

const FormItem = Form.Item;

class Registration extends Component {

  constructor() {
    super();

    this.state = {
      cloader: false,
      pan_scan: null,
      aadhaar_file: null,
      pan: '',
      pan_file_name: '',
      aadhaar_number: '',
      aadhaar_file_name: '',
      loader: false,
      dloader: false,
    };
  }

  handleSubmit = (e) => {
    this.setState({ loader: true });
    this.setState({ dloader: true });
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        const formData = new FormData();
        if (this.state.pan_scan) {
          formData.append('pan_scan', this.state.pan_scan);
        }
        if (this.state.aadhaar_file) {
          formData.append('aadhaar_file', this.state.aadhaar_file);
        }
        const vendor_id = localStorage.getItem('temp_vendor_id')?localStorage.getItem('temp_vendor_id'): 23;
        formData.append('id', vendor_id);
        formData.append('pan', values.pan);
        formData.append('aadhaar_number', values.aadhaar_number ? values.aadhaar_number : "");

        const endpoint = "/partner/temp-partner-edit/";

        this.setState({ cloader: true });

        createDataUnAuth(endpoint, formData)
          .then(res => {
            if (res.data?.status === 200) {
              this.setState({ cloader: false, loader: false });
              message.success('Company details added successfully');
              setTimeout(() => {
                this.setState({ dloader: false });
                window.location.href = '/thank-you';
              }, 3000);
            } else if (res.data?.status === 201) {
            } else {
              this.setState({ cloader: false, loader: false });
              message.error(res.data?.message);
            }
          })
          .catch(error => {
            this.setState({ cloader: false, loader: false });
            if (error.response?.status === 400) {
              if (error.response.data?.pan) {
                message.error(error.response.data['pan']);
              } else {
                message.error(error.response.data?.message || 'An error occurred.');
              }
              console.log(error.response.data, 'error');
            } else {
              console.log(error);
              message.error(error.toString());              
            }
          });
      } else {
        this.setState({ loader: false });
      }
    });
  }

  onChange = (event) => {
    const value = event.target.files[0];
    const name = event.target.name;
    this.setState({
      [name]: value,
    });
  }

  handleAadhaarChange = (e) => {
    let value = e.target.value;

    // Only digits, max 12
    const digits = value.replace(/\D/g, '').slice(0, 12);

    // Add space after every 4 digits: "1234 5678 9012"
    const formatted = digits.replace(/(.{4})/g, '$1 ').trim();

    // Update state and force field update
    this.setState({ aadhaar_number: formatted }, () => {
      this.props.form.setFieldsValue({ aadhaar_number: formatted });
    });
  };

  AutoCapitalize = (e) => {
    e.target.value = e.target.value.toUpperCase();
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    const formItemLayout = {
      labelCol: { xs: 24, sm: 24 },
      wrapperCol: { xs: 24, sm: 24 },
    };

    return (
      <div>
        <Form onSubmit={this.handleSubmit} style={{ marginTop: '3em' }} className="step-2">
          <Row>
            <Col lg={12} md={12} sm={12} xs={24}>
              <FormItem
                {...formItemLayout}
                label="PAN">
                {getFieldDecorator('pan', {
                  initialValue: this.state.pan ? this.state.pan : '',
                  rules: [
                    {
                      required: false,
                      pattern: new RegExp("[A-Z]{5}[0-9]{4}[A-Z]{1}"),
                      message: "Please enter a valid Pan number!"
                    }
                  ],
                })(
                  <Input onChange={this.AutoCapitalize} id="pan" maxLength={10} minLength={10} placeholder="ABCDE1234F" />
                )}
              </FormItem>
            </Col>
            <Col lg={12} md={12} sm={12} xs={24}>
              <FormItem
                {...formItemLayout}
                label="PAN card Scan">
                {getFieldDecorator('pan_scan', {
                  rules: [{ required: false, message: 'Please upload PAN card scanned copy' }],
                })(
                  <div>
                    <Input id='myFile2' name='pan_scan' type='file' onChange={this.onChange} style={{ width: '100%' }} />
                    {this.state.pan_file_name ? <a onClick={generateSignedUrl.bind(this, this.state.pan_file_name)} >See Pan Card Uploaded</a> : ''}
                  </div>
                )}
              </FormItem>
            </Col>
          </Row>

          <Row>
            <Col lg={12} md={12} sm={12} xs={24}>
              <FormItem
                {...formItemLayout}
                label="Aadhaar Card No.">
                {getFieldDecorator('aadhaar_number', {
                  initialValue: this.state.aadhaar_number !== "null" ? this.state.aadhaar_number : "",
                  rules: [{
                    required: false,
                    pattern: new RegExp(/^[2-9]{1}[0-9]{3}\s[0-9]{4}\s[0-9]{4}$/),
                    message: "Please enter a valid Aadhaar Card!",
                  }]
                })(
                  <Input allowClear placeholder="XXXX XXXX XXXX" maxLength={14} minLength={14} onChange={this.handleAadhaarChange}></Input>
                )}
              </FormItem>
            </Col>
            <Col lg={12} md={12} sm={12} xs={24}>
              <FormItem
                {...formItemLayout}
                label="Aadhaar Card Scan">
                {getFieldDecorator('aadhaar_file', {
                  rules: [{ required: false, message: 'Please upload Aadhaar Card Scanned file' }],
                })(
                  <div>
                    <Input id='myFile7' name='aadhaar_file' type='file' onChange={this.onChange} style={{ width: '100%' }} />
                    {this.state.aadhaar_file_name ?
                      <a onClick={generateSignedUrl.bind(this, this.state.aadhaar_file_name)} >See Aadhaar Card Uploaded</a> : ''}
                  </div>
                )}
              </FormItem>
            </Col>
          </Row>

          <FormItem style={{ marginTop: '3em' }}
            wrapperCol={{
              xs: { span: 24, offset: 0 },
              sm: { span: 24, offset: 0 },
            }}
          >
            <Button style={{ float: 'left' }} type="primary" onClick={this.props.handleBack} htmlType="button" icon="arrow-left">Back</Button>
            <Button style={{ float: 'right' }} type="primary" htmlType="submit" icon="check" loading={this.state.dloader}>Create Profile</Button>
          </FormItem>
        </Form>
        {this.state.cloader &&
          <div className="gx-loader-view gx-loader-position">
            <CircularProgress />
          </div>
        }
      </div>
    );
  }
}

const RegistrationForm = Form.create()(Registration);
export default RegistrationForm;